import { module, IController, IAugmentedJQuery, IScope, ITimeoutService, IOnChangesObject } from 'angular';
import { I18n } from '../../../../i18n/mx-internationalization';
import template from './mx-load-file.html';
import { SourceLoadingStatus } from '../../model/enumerations';

export class MxLoadFileCtrl implements IController {
	public contentType?: 'stream' | 'base64' | 'text';
	public value?: File | string | ArrayBuffer | null;
	public label?: string;
	public fileNameOut?: string;
	public filesFilter?: string;
	public sourceState?: number;
	public required?: boolean;

	private showLoading = false;
	private fileName?: string;

	public static $inject = ['$element', '$scope', '$timeout', 'mx.internationalization'];
	constructor(readonly $element: IAugmentedJQuery, readonly $scope: IScope, readonly $timeout: ITimeoutService, readonly i18n: I18n) {}

	public $onInit() {
		this.fileName = this.i18n.get('solutionBuilderAgent.components.mx-load-file.chooseFile');
		this.showLoading = false;
	}

	public $postLink() {
		const container = this.$element.find('input');
		container[0].addEventListener<'change'>('change', (evt) => this.onChange(evt), false);
	}

	public $onChanges(changes: IOnChangesObject) {
		if (changes.sourceState) {
			if (changes.sourceState.currentValue === SourceLoadingStatus.LOADED || changes.sourceState.currentValue === SourceLoadingStatus.REJECTED) {
				this.$timeout(() => (this.showLoading = false), 400);
			} else if (changes.sourceState.currentValue === SourceLoadingStatus.LOADING) {
				this.showLoading = true;
			}
		}
	}

	private onChange(evt: Event) {
		const files = (evt.target as HTMLInputElement).files;
		const reader = new FileReader();

		if (files && files.length > 0) {
			this.fileName = this.fileNameOut = files[0].name;

			if (this.contentType === 'stream') {
				this.$scope.$evalAsync(() => {
					this.value = files[0];
				});
				return;
			}

			reader.onloadend = () => {
				if (reader.error === null) {
					const result = reader.result;
					this.$scope.$evalAsync(() => {
						this.value = this.contentType === 'base64' ? (result as string).split('base64,')[1] : result;
					});
				}
			};

			if (this.contentType === 'text') {
				reader.readAsText(files[0]);
			} else if (this.contentType === 'base64') {
				reader.readAsDataURL(files[0]);
			}
		}
	}
}

export const MxLoadFileComponent = {
	bindings: {
		value: '=?',
		label: '@',
		fileNameOut: '=?fileName',
		filesFilter: '@',
		contentType: '@',
		sourceState: '<',
		required: '=?ngRequired',
	},
	controller: MxLoadFileCtrl,
	controllerAs: 'vm',
	template,
};

module('mx.SolutionBuilderAgent').component('mxLoadFile', MxLoadFileComponent);
